import createFields from './createFields';
import plain from './structure/plain';
export default createFields(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/Fields.js
// module id = UJz2
// module chunks = 1